import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getShopUid } from "../../../settings/domainManager";
import { navigate_to_shop_cart_invoice } from "../../../navigator/user/cart";

class WaitToPayCartsBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shop_uid: getShopUid(),
    };
  }
  render() {
    return (
      <div className="row mx-0 p-0 border rounded14 mb-3">
        <div className="col-12 p-3 border-bottom">
          <div className="row mx-0 px-0">
            <div className="col px-1 align-self-center">
              <p className="text-danger small mb-0">
                مدت زمان باقی مانده برای پرداخت مجدد
              </p>
            </div>
            <div className="col-auto px-1 align-self-center">
              <p className="text-danger small fw-bold mb-0">
                {this.props.cart.time_to_pay}
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 fw-bolder fs-4 p-3">
          <div className="row mx-0 px-0">
            <div className="col-auto align-self-center px-1">
              <Link
                to={navigate_to_shop_cart_invoice(
                  this.state.shop_uid,
                  this.props.cart.cart.uid,
                  "gateway"
                )}
              >
                <button className="btn px-3 rounded28 border color-main fw-bold fs-6">
                  تکمیل پرداخت
                </button>
              </Link>
            </div>
            <div className="col px-1">
              <p className="fs-7 text-muted mb-1" dir="ltr">
                جمع کل
              </p>
              <p className="fs-5 text-start mb-0">
                <span>{this.props.cart.payable_price.title}</span>
                <span className="fs-7 me-1">
                  {this.props.cart.payable_price.currency}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WaitToPayCartsBlock;
